export const getEmarConfirmProps = () => ({
  title: 'Are you sure you want to edit?',
  description: 'This information is taken from the NHS dm+d database.',
})

export const getStockConfirmProps = () => ({
  title: 'Are you sure you want to edit?',
  description:
    'If you change units, we won’t be able to track the expected stock.',
})
